import { Component } from '@angular/core';
import { I18NService } from '@socrates/socrates-shared';

@Component({
	selector: 'app-tos',
	templateUrl: './tos.component.html',
	standalone: false,
})
export class TosComponent {
	readonly sections = ['s1','s2','s3','s4','s5','s6','s7','s8','s9','s10','s11'];
	readonly today = new Date().toISOString().slice(0, 10);

	getMessage(key: string): string {
		return I18NService.getMessage(key);
	}
}
